import { redirect } from '@tanstack/react-router'

import { authStore, bootstrapSession } from './session'

let ready: Promise<void> | null = null

/**
 * Resolves once the session has been restored (or found absent). Started lazily by the first
 * page that needs it: public pages (offer pages opened from a QR code) never touch the refresh
 * cookie, so they can't rotate it underneath a signed-in tab.
 */
export function authReady(): Promise<void> {
  ready ??= bootstrapSession()
  return ready
}

/** For routes that need a signed-in user. Preserves the destination for after sign-in. */
export async function requireAuth(href: string) {
  await authReady()
  if (authStore.get().status !== 'authenticated') {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router redirect
    throw redirect({ to: '/login', search: { redirect: href } })
  }
}

/** For sign-in/sign-up pages: signed-in users go straight to the app. */
export async function redirectIfAuthenticated(target?: string) {
  await authReady()
  if (authStore.get().status === 'authenticated') {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router redirect
    throw redirect({ to: safeRedirect(target) })
  }
}

/** Only allow same-app relative redirects (prevents open-redirect via ?redirect=https://evil). */
export function safeRedirect(target: string | undefined): string {
  if (!target || !target.startsWith('/') || target.startsWith('//')) return '/app'
  return target
}
